import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, useMemo, useState } from 'react';
import { MaterialLabels } from '@alliance-disposal/transport-types';
import { useFormContext } from 'react-hook-form';
import { BasicMaterialsInfo } from '../../utils/materials-info';
import CollapsibleCard, { CollapsibleCardClosedActionButton, CollapsibleCardClosedSubHeader } from './CollapsibleCard';
import MaterialGuideDialog from './MaterialGuideDialog';
import { MaterialCard } from './material-card';
import { ProhibitedItemsFooter } from './prohibited-items-footer';
const DisabledOverlay = lazy(() => import('@wayste/sour-ui').then((module) => ({ default: module.DisabledOverlay })));
export const MaterialDetails = ({ materials, onMaterialSelected, fieldNames = {}, quoteUrl, guideUrl, contactPhone, contactPhoneDisplay, defaultProhibitedItems, }) => {
    const { materialField = 'selectedMaterial', addressField = 'selectedAddress', deliveryDateField = 'selectedDeliveryDate', sectionOpenField = 'materialSectionOpen', } = fieldNames;
    const [showMaterialGuide, setShowMaterialGuide] = useState(false);
    const { watch, setValue } = useFormContext();
    const watchSelectedAddress = watch(addressField);
    const watchSelectedDeliveryDate = watch(deliveryDateField);
    const watchSelectedMaterial = watch(materialField);
    const watchMaterialSectionOpen = watch(sectionOpenField);
    const watchServiceInfoFilled = watchSelectedAddress && watchSelectedDeliveryDate;
    // open when not chosen yet OR section is manually opened
    const isOpen = useMemo(() => {
        const shouldAutoOpen = watchServiceInfoFilled && !watchSelectedMaterial;
        return shouldAutoOpen || watchMaterialSectionOpen;
    }, [watchSelectedMaterial, watchServiceInfoFilled, watchMaterialSectionOpen]);
    // closed (summary) content
    const ClosedSummary = useMemo(() => {
        const label = (watchSelectedMaterial?.material &&
            (MaterialLabels[watchSelectedMaterial.material] || watchSelectedMaterial.material)) ||
            '';
        if (!label)
            return null;
        return (_jsx(CollapsibleCardClosedSubHeader, { children: _jsx("div", { className: "text-primary-foreground flex flex-col leading-3", children: _jsx("span", { className: "leading-tight", children: label }) }) }));
    }, [watchSelectedMaterial]);
    // options list (preserves original filters + sort)
    const availableMaterials = useMemo(() => {
        if (materials && materials.length > 0) {
            return materials;
        }
        return BasicMaterialsInfo.map((v) => ({ ...v, selected: false }));
    }, [materials]);
    return (_jsx(DisabledOverlay, { active: !watchServiceInfoFilled, tooltipMsg: "Please select an address and date first", children: _jsxs(CollapsibleCard, { isOpen: isOpen, header: 'Select Material', subHeader: _jsxs("span", { className: "text-base font-normal leading-none", children: ["Pricing changes based on material.", ' ', _jsx("button", { type: "button", className: "link link--inline", onClick: () => setShowMaterialGuide(true), children: "Learn more" })] }), closedView: ClosedSummary, closedActionButton: watchSelectedMaterial ? (_jsx(CollapsibleCardClosedActionButton, { onClick: () => {
                    setValue(sectionOpenField, true);
                }, children: "Change" })) : null, footer: _jsx(ProhibitedItemsFooter, { material: watchSelectedMaterial?.material, defaultProhibitedItems: defaultProhibitedItems }), children: [_jsxs("div", { className: "flex flex-col gap-y-4", children: [availableMaterials.map((matInfo) => {
                            return _jsx(MaterialCard, { option: matInfo, onSelect: (matInfo) => onMaterialSelected(matInfo) }, matInfo.material);
                        }), _jsx(MaterialCard, { option: {
                                selected: false,
                                id: 'other',
                                material: 'other',
                                type: 'flat',
                                sizes: [],
                                allowOnlineCheckout: true,
                                doesNotService: false,
                            }, onSelect: (_) => {
                                if (quoteUrl) {
                                    window.location.href = quoteUrl;
                                }
                            } }, "other")] }), _jsx(MaterialGuideDialog, { open: showMaterialGuide, onClose: () => setShowMaterialGuide(false), quoteUrl: quoteUrl, guideUrl: guideUrl, contactPhone: contactPhone, contactPhoneDisplay: contactPhoneDisplay })] }) }));
};
export default MaterialDetails;
//# sourceMappingURL=MaterialDetails.js.map